module.exports = __webpack_public_path__ + "img/roundups_fallback_error_new.0b0307d8.png";